import React from 'react';
import { Ico } from './Icons';

const SIDEBAR_ITEMS = [
  { id: 'todas', icon: 'inbox', label: 'Bandeja', always: true },
  { id: 'ventas', icon: 'trending', label: 'Ventas', area: 'ventas' },
  { id: 'atencion', icon: 'headphones', label: 'Atención', area: 'atencion' },
  { id: 'soporte', icon: 'tool', label: 'Soporte', area: 'soporte' },
  { id: 'marketing', icon: 'megaphone', label: 'Marketing', area: 'marketing' },
  { id: 'outbound', icon: 'send', label: 'Outbound', always: true },
  { id: 'implementacion', icon: 'tool', label: 'Implementación', always: true },
  { id: 'catalogo', icon: 'chart', label: 'Catálogo', always: true },
  { id: 'criticas', icon: 'dollar', label: 'Críticas', always: true },
  { id: 'pendientes', icon: 'alert', label: 'Sin asignar', always: true },
  { id: 'derivadas', icon: 'users', label: 'Derivadas IA', always: true },
  { id: 'metricas', icon: 'chart', label: 'Métricas', always: true },
];

function Sidebar({ filtro, setFiltro, areasHabilitadas, onLogout }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-logo">WC</div>
      {SIDEBAR_ITEMS.map((item) => {
        if (item.area && !areasHabilitadas.includes(item.area)) return null;
        return (
          <button
            key={item.id}
            className={`sidebar-btn ${filtro === item.id ? 'active' : ''}`}
            onClick={() => setFiltro(item.id)}
            title={item.label}
          >
            <Ico name={item.icon} size={20} />
          </button>
        );
      })}
      <div className="sidebar-spacer" />
      <button className="sidebar-btn" onClick={onLogout} title="Cerrar sesión"><Ico name="logout" size={20} /></button>
    </aside>
  );
}

export default React.memo(Sidebar);
